// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1cavx","header":"MessagesList_header__3tZTS","chat":"MessagesList_chat__3cVGi"};